import { Building2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n/I18nContext";
import { translateError } from "@/i18n/errors";
import { ConfirmButton } from "@/components/admin/ConfirmButton";

// Abonnements: REF-scoped mini-site plans of this owner (app + email + REFs), REF + business name shown.
export const BusinessPlans = ({ plans, testId }) => {
  const { t, fmtDate } = useI18n();
  return (
    <div className="mt-2 min-w-0 space-y-1.5 rounded-lg border border-emerald-500/30 bg-emerald-950/20 p-2.5" data-testid={testId}>
      <p className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wide text-emerald-200"><Building2 className="h-3.5 w-3.5" /> {t("biz.plansTitle")}</p>
      {plans.map((p) => (
        <div key={p.id} className="min-w-0 text-xs text-neutral-200" data-testid={`${testId}-${p.id}`}>
          <p className="[overflow-wrap:anywhere]">{t("biz.planRow", { app: p.app, n: p.refs.length, status: t(`biz.st.${p.status}`), until: p.until ? fmtDate(p.until) : "—", emp: p.employees })}</p>
          <p className="text-neutral-400 [overflow-wrap:anywhere]">{p.refs.slice(0, 30).map((r) => (p.names[r] ? `${r} (${p.names[r]})` : r)).join(" · ")}{p.refs.length > 30 ? " …" : ""}</p>
          {p.cancellable && (
            <ConfirmButton title={t(p.cancel_at_period_end ? "biz.adminResume" : "biz.adminStop")} description={t("biz.unsubList", { app: p.app, n: p.refs.length }) + " " + p.refs.join(", ")}
              className={`mt-1 ${p.cancel_at_period_end ? "btn-gold" : "btn-red"} btn-sm`} testId={`${testId}-${p.id}-renewal`}
              onConfirm={() => api.post(`/admin/minisite/plans/${p.id}/renewal`, { cancel: !p.cancel_at_period_end }).then(() => toast.success(t("biz.saved"))).catch((err) => toast.error(translateError(err, t)))}>
              {t(p.cancel_at_period_end ? "biz.adminResume" : "biz.adminStop")}
            </ConfirmButton>
          )}
        </div>
      ))}
    </div>
  );
};
